import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

export default function accesoCliente() {
  return (
    <div>
      <Navbar />
      <section className="relative text-dark-gray overflow-hidden md:flex md:h-screen py-36 items-center bg-sidom-light dark:bg-sidom-blue">
        <div className="container relative">
          <div className="grid md:grid-cols-2 grid-cols-1 text-dark-gray  dark:text-white/60 items-center gap-6">
            <div className="">
              <h5 className="font-semibold leading-normal text-[20px] mt-6">
                Acceso Cliente
              </h5>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
